<template>
    <b-badge :variant="variant">{{ label }}</b-badge>
</template>

<script>
const STATUS_CONFIG = {
    pending: { variant: 'warning', label: 'Pending' },
    sent: { variant: 'info', label: 'Sent' },
    accepted: { variant: 'success', label: 'Accepted' },
    declined: { variant: 'danger', label: 'Declined' },
    no_response: { variant: 'secondary', label: 'No Response' },
}

export default {
    name: 'RSVPStatusBadge',
    props: {
        status: {
            type: String,
            default: 'pending',
            validator: (val) => Object.keys(STATUS_CONFIG).includes(val),
        },
    },
    computed: {
        variant() {
            return (STATUS_CONFIG[this.status] || STATUS_CONFIG.pending).variant
        },
        label() {
            return (STATUS_CONFIG[this.status] || STATUS_CONFIG.pending).label
        },
    },
}
</script>
